import React from "react";

// Style \\
import "../../assets/styles/sections/appointmentHero.scss";

const AppointmentHero = () => {
  return (
    <section className="appointHero">
      <div className="appointHero_bg">
        <div className="container">
          <div className="appointHero_items">
            <p>Home / Appointment</p>
            <h2>Book an Appointment</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentHero;
